import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M4 10h12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 14h9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Euro";
const Euro = memo(themed(Icon));
export {
  Euro
};
//# sourceMappingURL=euro.js.map
